import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "../reducers/rootReducer";
export function configureCustomStore(thunkExtraArgument) {
    return configureStore({
        reducer: rootReducer,
        // using dev tools can lead to spam if creating a new store and not reusing a single one
        devTools: {
            name: document.title + " # 3PQ FE",
        },
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            thunk: {
                extraArgument: thunkExtraArgument,
            },
            immutableCheck: false, // performance issue for large states
            serializableCheck: false, // performance issue for large states
        }),
    });
}
//# sourceMappingURL=configureCustomStore.js.map